// extracted by mini-css-extract-plugin
export default {"scope":"ryD9V","scope--has-action":"VNODt","scope--is-disabled":"BMq1y","scope--is-active":"ejwXz","icon":"Rc6gh","label":"AE+UA","description":"JxqS1","action":"_1pIEh"};